import type { WebModule } from '../registry';

/**
 * AI module (client side, WS-18 — `docs/AI-PIPELINE.md`).
 *
 * No nav entry, no routes, no doc subscriptions: AI is not a *place* in this app, it's a
 * capability other modules reach for. Like `sharing`, it is a foundation module whose
 * surface is exactly what this index re-exports.
 */
export const aiWebModule: WebModule = {
  id: 'ai',
};

export { useAiQuick, type AiQuickState, type UseAiQuick } from './hooks';
export { postAiQuick, AssistantNappingError, AiRequestError } from './api';
